/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Laravel
 * OpenAPI spec version: 0.0.1
 */

export type ActivityStatus = typeof ActivityStatus[keyof typeof ActivityStatus];


export const ActivityStatus = {
  concept: 'concept',
  active: 'active',
} as const;
